var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2715,4.0347 L17.9655,6.7287 L16.0185,8.6787 L13.3235,5.9837 L15.2715,4.0347 Z M19,20 C19.55,20 20,20.45 20,21 C20,21.55 19.55,22 19,22 L19,22 L5,22 C4.45,22 4,21.55 4,21 C4,20.45 4.45,20 5,20 L5,20 L19,20 Z M13.9485,2.5297 C14.6505,1.8247 15.9235,1.8597 16.6645,2.5987 L16.6645,2.5987 L19.4035,5.3377 C20.1685,6.1037 20.1995,7.3217 19.4715,8.0517 L19.4715,8.0517 L10.4745,17.0487 C10.1495,17.3737 9.7185,17.5757 9.2605,17.6177 L9.2605,17.6177 L5.0905,17.9957 C5.0605,17.9987 5.0305,17.9997 5.0005,17.9997 C4.7365,17.9997 4.4815,17.8957 4.2925,17.7067 C4.0835,17.4967 3.9775,17.2047 4.0035,16.9097 L4.0035,16.9097 L4.3825,12.7397 C4.4245,12.2827 4.6265,11.8507 4.9525,11.5257 L4.9525,11.5257 L13.9485,2.5297 Z",
    id: "path-1",
    fill: "#858585",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9dc4bfe2.svg";
export { ForwardRef as ReactComponent };